import {
    TableContainer,
    Table,
    TableBody,
    Paper,
    Typography,
    Box, useTheme
} from "@mui/material";
import {BetboardTableHeaders} from "./components/BetboardTableHeaders";
import {formatDateToMonthDay} from "../../../utils/timeUtils";
import React from "react";
import {BetboardTableRow} from "./components/BetboardTableRow";
import {useNavigate} from "react-router-dom";
import {BetboardRow} from "../../../types/types";

type BetboardTableProps = {
    rows: BetboardRow[]
    currentDate: number
    sport: string
    label: string
}

export const BetboardTable = (
    {
        rows,
        currentDate,
        sport,
        label,
    }: BetboardTableProps
) => {
    const navigate = useNavigate();
    const theme = useTheme()
    const handleRowClick = (team: string, oTeam: string, date: string) =>
        navigate(`/${sport}/matchupTeams/${team}/${oTeam}/${date}?view=trend-finder`);
    const formattedTitle = `${formatDateToMonthDay(currentDate)} ${label.toUpperCase()} Games`

    return (
        <Box
            style={{width: '100%'}}
        >
            <Typography
                variant="caption"
                display="flex"
                justifyContent="center"
                mt={3}
                style={{color: theme.palette.grey[500]}}
            >
                {formattedTitle}
            </Typography>
            <TableContainer
                component={Paper}
                style={{
                    marginBottom: '8px',
                    marginTop: '8px'
                }}
            >
                <Table
                    sx={{minWidth: 650}}
                    style={{margin: 0, padding: 0}}
                    aria-label="simple table"

                >
                    <BetboardTableHeaders sport={sport}/>
                    <TableBody
                        style={{margin: 0, padding: 0}}
                    >
                        {
                                rows.map((row: BetboardRow, index: number) => {
                                    return (
                                        <BetboardTableRow
                                            sport={sport}
                                            row={row}
                                            key={index}
                                            handleRowClick={handleRowClick}
                                        />
                                    )
                                })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>

    );
}